import styles from './index.module.scss';
import { OnshapeLogo } from '@components/icons';
import { Button } from '@phi/components';
import { h } from 'vue';
import { Unary } from '@vaaas/fpts/data';
import { Flex } from '@phi/components/layout';

export const LogInWithOnshape = (light: boolean, onClick: Unary<MouseEvent, void>) =>
    h(Button, { block: true, class: [styles.height, 'log-in-with-onshape'], onClick }, () =>
        h(Flex, { gap: 'tight', align: 'center', justify: 'center', direction: 'row' }, () => [
            h('span', { class: styles.logo }, OnshapeLogo(light)),
            h('span', 'Log In with Onshape Account'),
        ]));
